module.exports = __webpack_public_path__ + "fonts/Hero-Regular.4510b771.ttf";